<script setup lang="ts">
import type { SelectItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { SelectItem, SelectItemIndicator, SelectItemText, useForwardProps } from 'reka-ui';
import { Check } from '@lucide/vue';
import { cn } from '@/utils/shadcn';

const props = defineProps<SelectItemProps & { class?: HTMLAttributes['class'] }>();
const delegatedProps = reactiveOmit(props, 'class');
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectItem
    data-slot="select-item"
    v-bind="forwardedProps"
    :class="cn(
      'relative flex items-center gap-2 w-full px-3 py-2 text-sm text-text-primary rounded-[8px] outline-none cursor-default select-none transition-colors duration-150',
      'data-[highlighted]:bg-(--color-primary-subtle) data-[highlighted]:text-(--color-primary)',
      'data-[state=checked]:font-medium',
      'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      props.class,
    )"
  >
    <SelectItemText class="flex-1 truncate">
      <slot></slot>
    </SelectItemText>
    <SelectItemIndicator class="flex items-center justify-center shrink-0 text-primary">
      <Check class="size-4" />
    </SelectItemIndicator>
  </SelectItem>
</template>
